<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-to-do`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v32h32V8zM21.064 26.294l11.768-10.963a1 1 0 011.322-.037l.092.087 1.363 1.463a1 1 0 01.036 1.322l-.086.091-13.895 12.945a1 1 0 01-1.3.055l-.091-.082-7.971-8.03a1 1 0 01-.079-1.32l.084-.094 1.42-1.41a1 1 0 011.32-.078l.093.084 5.924 5.967 11.768-10.963-11.768 10.963z"/></svg>
</template>
<script>

export default {
  name: 'IconToDo',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
